import React, { Fragment, useEffect, useState } from "react";

import { logoutHandler } from "../../utils/user";
import { BACKEND_URL } from "../../App";

const AuthCheck = (props) => {
  const { } = props;

  const [authCheckStart, setAuthCheckStart] = useState(false);

  useEffect(() => {
    if (!authCheckStart) {
      setAuthCheckStart(true);

      if (localStorage.getItem('token')) {
        authCheck();
      }
      
      setInterval(() => {
        // console.log('in setInterval')
        // console.log('lsToken', localStorage.getItem('token'));
        if (localStorage.getItem('token')) {
          authCheck();
        }
      }, 1000 * 60 * 60);
    }
  }, []);

  const authCheck = () => {
    //// check auth validity and logout
      fetch(BACKEND_URL + "/auth/auth-check", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          console.log(res);
  
          //// logout when invalid auth
          if (res.status === 401) {
            logoutHandler();
            window.location.reload();
          }
          if (res.status !== 200) {
            throw new Error("Failed to fetch auth check.");
          }
          return res.json();
        })
        .then((resData) => {
          console.log(resData);
        })
        .catch((err) => {
          console.log(err);
        });
    
  };

  return <Fragment></Fragment>;
};

export default AuthCheck;
